<script>
  import { post } from "../../js/api";
  import { setToken, setUsername } from "../../js/local";

  let nick = "";
  let passwd = "";

  let token = "";

  let login = async () => {
    const response = await post("Login", {
      user: nick,
      passwd,
    });
    token = response.t ? response.t : "";
    if (token !== "") {
      setToken(token);
      setUsername(nick);
      location.href = "/inicio";
    } else {
      nick = "";
      passwd = "";
    }
  };
</script>

<div class="screen fullheight">
  <div class="screenheader nomargin">
    <div class="headertitletxt leftalign nomargin">
      <strong class="textbold">Iniciar</strong> sesión
    </div>
    <img
      src="/images/logo-uex-white.png"
      loading="lazy"
      width="80"
      sizes="(max-width: 479px) 18vw, (max-width: 767px) 11vw, (max-width: 991px) 65px, 80px"
      srcset="/images/logo-uex-white-p-500.png 500w, /images/logo-uex-white.png 780w"
      alt=""
      class="logoheader"
    />
  </div>
  <div class="screenbody fullheight responsiveheight">
    <div class="centercontent">
      <div class="autoformsection nomargin verticaldirection">
        <div class="div-block">
          <img
            src="/images/user.svg"
            loading="lazy"
            alt=""
            class="iconosmall nopadding marginright"
          />
          <div class="formtitle widthlogin">Usuario</div>
        </div>
        <div class="writefield widthlogin nomargin">
          <div class="textstyle">
            <input
              type="text"
              bind:value={nick}
              placeholder="Introduce tu nombre de usuario"
            />
          </div>
        </div>
      </div>
      <div class="autoformsection verticaldirection">
        <div class="div-block">
          <img
            src="/images/password.svg"
            loading="lazy"
            alt=""
            class="iconosmall nopadding marginright customheight"
          />
          <div class="formtitle widthlogin">Contraseña</div>
        </div>
        <div class="writefield widthlogin nomargin">
          <div class="textstyle">
            <input
              type="password"
              bind:value={passwd}
              placeholder="Introduce tu contraseña"
            />
          </div>
        </div>
      </div>
      <div
        class="greenbuttonstyle widthlogin w-button"
        on:click={() => login()}
      >
        Iniciar sesión
      </div>
    </div>
  </div>
  <div class="screenfooter">
    <img
      src="/images/logo-uex-complete-black.png"
      loading="lazy"
      width="300"
      sizes="(max-width: 479px) 83vw, 249.99998474121094px"
      srcset="/images/logo-uex-complete-black-p-500.png 500w, /images/logo-uex-complete-black-p-800.png 800w, /images/logo-uex-complete-black-p-1080.png 1080w, /images/logo-uex-complete-black-p-1600.png 1600w, /images/logo-uex-complete-black-p-2000.png 2000w, /images/logo-uex-complete-black-p-2600.png 2600w, /images/logo-uex-complete-black-p-3200.png 3200w, /images/logo-uex-complete-black.png 3994w"
      alt=""
      class="logobottom"
    />
  </div>
</div>

<style>
  input {
    width: 100%;
    height: 100%;
    background-color: transparent;
    margin: 0px;
    border: 0px;
  }

  input::placeholder {
    color: #aaaaaa;
  }

  div.textstyle {
    margin: 0px;
    padding: 0px 5px 0px 5px;
  }

  div.writefield {
    padding: 0px !important;
  }
</style>
